import { render, staticRenderFns } from "./settingLanguages.vue?vue&type=template&id=973ddb1a&scoped=true&"
import script from "./settingLanguages.vue?vue&type=script&lang=js&"
export * from "./settingLanguages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973ddb1a",
  null
  
)

export default component.exports